/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Statistic, StatisticLabel, StatisticValue } from 'semantic-ui-react'
import { intlFormatMoneyWithCompact, ONE_THOUSAND } from '../../../../../helpers/money'
import { CardContent } from '../../../Shared/Card'
import React from 'react'
import useUser from '../../../../Shared/UserProvider/useUser'
import { format } from 'date-fns'
import { fr } from 'date-fns/locale'
import { useTranslation } from 'react-i18next'
import { CardTitle } from '../../../Shared/CardTitle'
import { intlFormatNumberWithCompact, TEN_THOUSAND } from '../../../../../helpers/number'

const NegativeActivityCardContent = ({revenuesMissed, missedOrder}) => {
    const [t] = useTranslation()
    const {user} = useUser()

    return (
      <CardContent
        css={css`
            display: grid;
            place-items: center;
            gap: .5rem;
            grid-template-areas: 'title' 'a' 'b';
            grid-template-rows: 30px 1fr 1fr;
        `}
      >
          <>
              <CardTitle
                title={format(new Date(), 'MMMM', {locale: fr})}
              />

              <Statistic
                css={css`
                    grid-area: a;

                    &.ui.statistic, &.ui.statistic + .ui.statistic {
                        margin: 0;
                    }
                `}
                color="red"
              >
                  <StatisticValue>
                      {intlFormatMoneyWithCompact(revenuesMissed, user.getCompanyCurrency(), user.getCompanyLocale(), ONE_THOUSAND)}
                  </StatisticValue>
                  <StatisticLabel>
                      {t('dashboard.negative_activity.not_acquired_revenues')}
                  </StatisticLabel>
              </Statistic>

              <Statistic
                css={css`
                    grid-area: b;

                    &.ui.statistic, &.ui.statistic + .ui.statistic {
                        margin: 0;
                    }
                `}
                size="tiny"
                color="red"
              >
                  <StatisticValue>
                      {intlFormatNumberWithCompact(missedOrder, user.getCompanyLocale(), TEN_THOUSAND)}
                  </StatisticValue>
                  <StatisticLabel>
                      {t('dashboard.negative_activity.not_acquired_orders', { count: missedOrder })}
                  </StatisticLabel>
              </Statistic>
          </>
      </CardContent>
    )
}

export { NegativeActivityCardContent }
